// extracted by css-extract-rspack-plugin
export default {"button":"button-KqXTeV","icon":"icon-rzxum4"};